import { SCREEN } from '@pay24/charge/src/navigation/screen'
import { colors } from '@pay24/common'

const adminCategory = [
  {
    icon: 'account-box',
    iconBg: colors.brown,
    title: 'agent',
    path: SCREEN.USERS,
  },
  {
    icon: 'clipboard-flow-outline',
    iconBg: colors.metal,
    title: 'report',
    path: SCREEN.REPORTS,
  },
  {
    icon: 'face-agent',
    iconBg: colors.purple,
    title: 'administration',
    path: SCREEN.ADMINISTRATION,
  },
  {
    icon: 'office-building-outline',
    iconBg: colors.violet,
    title: 'marketing',
    path: SCREEN.MARKETING,
  },
  {
    icon: 'garage',
    iconBg: colors.darkGreen,
    title: 'garage',
    path: SCREEN.GARAGE,
  },
]
const agentCategory = [
  {
    icon: 'clipboard-list-outline',
    iconBg: colors.darkGreen,
    title: 'report',
    path: 'report',
    roles: {
      authRequired: true,
      isChargeOwner: true,
      isChargeUserViewer: true,
      isChargeUserAdmin: true,
    },
  },
  {
    icon: 'monitor-cellphone',
    iconBg: colors.purple,
    title: 'monitoring',
    path: SCREEN.MONITORING,
    roles: {
      authRequired: true,
      isChargeOwner: true,
      isChargeUserViewer: true,
      isChargeUserAdmin: true,
    },
  },
  {
    icon: 'account-multiple-outline',
    iconBg: colors.brown,
    title: 'accesses',
    path: SCREEN.ACCESS,
    roles: {
      authRequired: true,
      isChargeOwner: true,
      isChargeUserAdmin: true,
    },
  },
  {
    icon: 'star-box-outline',
    iconBg: colors.metal,
    title: 'brands',
    path: SCREEN.BRANDS,
    roles: {
      authRequired: true,
      isChargeOwner: true,
      isChargeUserAdmin: true,
    },
  },
  {
    icon: 'clipboard-list-outline',
    iconBg: colors.violet,
    title: 'charger',
    path: SCREEN.POINTS,
    roles: {
      authRequired: true,
      isChargeOwner: true,
      isChargeUserAdmin: true,
    },
  },
]
export const CATEGORY_MAP = {
  [SCREEN.ADMIN]: adminCategory,
  [SCREEN.AGENT]: agentCategory,
}
export const COLLAPSABLE_MENUS = [SCREEN.ADMIN, SCREEN.AGENT]
